import { render, staticRenderFns } from "./WorkFileIdentificationForm.vue?vue&type=template&id=3ee1e3e6"
import script from "./WorkFileIdentificationForm.vue?vue&type=script&lang=ts"
export * from "./WorkFileIdentificationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports